import {NgModule} from '@angular/core';
import {CmsConfig, provideConfig} from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        digitalNativeCheckout: {
          module: () =>
            import('../../../digital-native-checkout/digital-native-checkout.module').then(
              (m) => m.DigitalNativeCheckoutModule
            ),
          cmsComponents: ['CheckoutDataEntry'],
        },
      },
    } as CmsConfig),
  ],
})
export class DigitalNativeCheckoutFeatureModule {}
